module.exports = __webpack_public_path__ + "6b52c218f25d1772a20a68b136b93f4b.png";